import { css, styled } from 'canoe';

import { WithContentOverflow } from './WithContentOverflow';

export const CheckeredBackground = styled(WithContentOverflow)`
  ${({ theme }) => css`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    min-width: 100%;
    min-height: 100%;

    background: repeating-conic-gradient(
        ${theme.colors.GlitterGrayL20} 0% 25%,
        ${theme.colors.White} 0% 50%
      )
      50% / 20px 20px;
  `}
`;
